import { cn } from "@/utils/cn"
import type { AvatarProps } from "./Avatar.types"

const sizeClasses = {
  sm: "h-[40px] w-[40px] min-w-[40px] min-h-[40px] text-[16px]",
  md: "h-[50px] w-[50px] min-w-[50px] min-h-[50px] text-[20px]",
  lg: "h-[80px] w-[80px] min-w-[80px] min-h-[80px] text-[32px]",
  xl: "h-[150px] w-[150px] min-w-[150px] min-h-[150px] text-[48px]",
}

const variantClasses = {
  default: "bg-dark-500 border-primary",
  primary: "bg-primary border-none",
}

type ButtonStyleProps = Pick<AvatarProps, "variant" | "size" | "src">

export const getAvatarStyles = ({ variant, size = "md" }: ButtonStyleProps) => {
  return {
    wrapper: cn(
      "relative inline-flex items-center justify-center overflow-hidden rounded-full border border-transparent font-semibold text-primary-100 transition-all duration-300",
      sizeClasses[size],
      variantClasses[variant]
    ),
    image: "h-full w-full object-cover",
  }
}
